<template>
  <v-container>
    <v-row>
      <v-col :cols="cols">
        <v-select
          v-model="selectedOption"
          :items="options"
          return-object
          :label="label"
          outlined
          :loading="loading"
          @change="changeOption"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
  props: {
    cols: {
      type: Number,
      default: 3
    },
    options: {
      type: Array,
    },
    label: {
      type: String,
      default: "Escolha uma opção"
    },
    selected: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectedOption: {},
    };
  },
  mounted() {
    if (!isEmpty(this.selected)) {
      this.selectedOption = this.selected;
      this.changeOption();
    }
    this.loading = false;
  },
  methods: {
    changeOption() {
      this.$emit("change", this.selectedOption);
    }
  }

}
</script>
<style>
</style>